//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapMutations } from 'vuex'
import seo from '~/mixins/seo'
import documentCategoriesQuery from '~/apollo/queries/documents/categories'
import documentSubcategoriesQuery from '~/apollo/queries/documents/subcategories'
import categoryDocumentsQuery from '~/apollo/queries/documents/category-documents'
import subcategoryDocumentsQuery from '~/apollo/queries/documents/subcategory-documents'
import filter from '~/mixins/filter'

export default {
  mixins: [seo, filter],
  data () {
    return {
      categoryId: '',
      subcategoryId: '',
      fetched: false
    }
  },
  apollo: {
    documentCategories: {
      query: documentCategoriesQuery,
      prefetch: true,
      result ({ data, loading, networkStatus }) {
        if (!this.categoryId && this.documentCategories && this.documentCategories.length > 0) {
          this.categoryId = this.documentCategories[0].documentId
        }
      }
    },
    documentSubcategories: {
      query: documentSubcategoriesQuery,
      prefetch: true,
      variables () {
        return { documentId: this.categoryId }
      }
    },
    categoryDocuments: {
      query: categoryDocumentsQuery,
      prefetch: true,
      variables () {
        return { documentId: this.categoryId }
      },
      result ({ data, loading, networkStatus }) {
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    },
    subcategoryDocuments: {
      query: subcategoryDocumentsQuery,
      prefetch: true,
      variables () {
        return { documentId: this.subcategoryId }
      },
      result ({ data, loading, networkStatus }) {
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    }
  },
  computed: {
    categoryName () {
      const obj = (this.documentCategories && this.categoryId) ? this.documentCategories.find(el => el.documentId === this.categoryId) : null

      if (obj) {
        return obj.name
      } else {
        return null
      }
    },
    subcategoryName () {
      const obj = (this.documentSubcategories && this.subcategoryId) ? this.documentSubcategories.find(el => el.documentId === this.subcategoryId) : null

      if (obj) {
        return obj.name
      } else {
        return null
      }
    },
    subcategoriesAndDocuments () {
      const ret = []
      if (this.subcategoryDocuments) {
        ret.push({ name: this.subcategoryDocuments.name, files: [] })
        const files = ret[ret.length - 1].files
        this.subcategoryDocuments.files.forEach((file) => {
          files.push(file)
        })
        return ret
      } else if (this.categoryDocuments && this.categoryDocuments.document_subcategories) {
        this.categoryDocuments.document_subcategories.forEach((subcategory) => {
          ret.push({ name: subcategory.name, files: [] })
          const files = ret[ret.length - 1].files
          subcategory.files.forEach((file) => {
            files.push(file)
          })
        })
        return ret
      } else {
        return null
      }
    },
    productsInternalName () {
      let ret = ''
      if (this.categoryDocuments && this.categoryDocuments.product_category) {
        if (this.categoryDocuments.product_category.isTargetedEcuCategory) {
          ret = 'targeted package'
        } else {
          this.categoryDocuments.product_category.products.forEach((product) => {
            if (product.internalName) {
              ret += product.internalName + ','
            } else {
              ret += product.name + ','
            }
          })
        }
      }
      return ret
    }
  },
  watch: {
    categoryId () {
      if (this.categoryId !== this.$store.getters['downloads/category']) {
        this.subcategoryId = ''
      }
      this.setCategory(this.categoryId)
      this.fetched = false
    },
    subcategoryId () {
      this.setSubcategory(this.subcategoryId)
      this.fetched = false
    }
  },
  created () {
    this.seoTitle = 'Downloads'
  },
  mounted () {
    this.setDownloads(JSON.parse(localStorage.getItem('downloads')))
    this.categoryId = this.$store.getters['downloads/category']
    this.subcategoryId = this.$store.getters['downloads/subcategory']
  },
  methods: {
    ...mapMutations({
      setDownloads: 'downloads/setDownloads',
      setCategory: 'downloads/setCategory',
      setSubcategory: 'downloads/setSubcategory'
    })
  }
}

